// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `canvas {
    display: block;
}
body {
    margin: 0;
    overflow: hidden;
}

#render-container {
    user-select: none;
    cursor: default;
}
`, "",{"version":3,"sources":["webpack://./res/style/index.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;AACA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB","sourcesContent":["canvas {\n    display: block;\n}\nbody {\n    margin: 0;\n    overflow: hidden;\n}\n\n#render-container {\n    user-select: none;\n    cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
